import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  DELETE_MEDICATION_TEMPLATE_REQUEST,
  GET_MEDICATION_TEMPLATES_REQUEST,
} from "../../../redux/actions";
import { medicationTemplatesSelector } from "../../../redux/selectors/treatmentPlansSelector";
import { FullPageContainer } from "../../common/FullPageContainer/FullPageContainer";
import { Modal } from "../../common/Modal/Modal";
import { NoDataPage } from "../../common/NoDataPage/NoDataPage";
import { MedicationTemplateControls } from "./components/MedicationTemplateControls/MedicationTemplateControls";
import { MedicationTemplateTable } from "./components/MedicationTemplateTable/MedicationTemplateTable";

export const MedicationTemplatePage = () => {
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState<number | null>(null);
  const medicationPlans = useSelector(medicationTemplatesSelector);

  useEffect(() => {
    dispatch({
      type: GET_MEDICATION_TEMPLATES_REQUEST,
      payload: { searchString: searchText }
    });
  }, [dispatch, searchText]);

  const openModal = (id: number) => {
    setOpen(true);
    setIdToDelete(id);
  };

  const closeModal = () => {
    setOpen(false);
  };

  const deleteTemplate = () => {
    dispatch({
      type: DELETE_MEDICATION_TEMPLATE_REQUEST,
      payload: { id: idToDelete, shouldLoadList: true, searchString: searchText }
    });
    closeModal();
  };

  return (
    <FullPageContainer>
      <>
        <MedicationTemplateControls updateSearchParams={setSearchText} />
        {medicationPlans && medicationPlans.length ? (
          <MedicationTemplateTable
            data={medicationPlans}
            deleteTemplate={openModal}
          />
        ) : (
          <NoDataPage
            message="No results found"
            description="Please, change the search criteria"
          />
        )}
        <Modal
          deleteConfirmation
          open={open}
          title={"Delete template"}
          message={"Are you sure you want to delete this medication template?"}
          handleConfirm={deleteTemplate}
          handleCancel={closeModal}
        />
      </>
    </FullPageContainer>
  );
};
